import React from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Pencil } from 'lucide-react';
import { makeStyles } from "@material-ui/core/styles";

import * as Actions from '../../../../Reducers/actions'
import { useNavigate } from 'react-router-dom';

function EditExternalApiButton(props) {
    const navigate = useNavigate();
    const classes = useStyles();

    return (
        <button 
            className={classes.iconButton}
            onClick={() => navigate(`/modifyapi/${props.uniqueId}`)}
        >
            <Pencil className={classes.iconButton__icon} />
        </button>
    )
}

const useStyles = makeStyles({
    iconButton: {
        height: "32px",
        width: "32px",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        borderRadius: "4px",
        border: "none",

        backgroundColor: "#F8F8F8",

        "&:hover": {
            backgroundColor: "#EDEDED",
            cursor: "pointer",
        },
    },

    iconButton__icon: {
        height: "20px",
        width: "20px",

        display: "block",
    },
});

const mapStateToProps = state => ({
    lists: state.lists,
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
})

export default compose(connect(
    mapStateToProps,
    mapDispatchToProps
))(EditExternalApiButton);